module.exports = __webpack_public_path__ + "img/injective-3.031dd99e.webp";